"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenantProductRegistry = void 0;
/*
This is the registry for override on a platform where we
do not have productId, productName and tenantId in params.
This should be removed once platform adds required info in URL.
*/
var Registry_1 = require("./Registry");
var playtechPlatformConfig = {
    accountId: '',
    gsId: '135',
    gpId: 'POP',
};
exports.tenantProductRegistry = {
    tenantProducts: {
        'bifortuna.cz': {
            tenantId: 'c90b082f-7d06-44b6-9815-8cd24635c62c',
            platformConfig: playtechPlatformConfig,
            products: (_a = {},
                _a[Registry_1.registry.products.luckysix.name] = {
                    productId: '324a2093-8d20-47ef-a0ef-388e533ba68d',
                },
                _a),
        },
        'casapariurilor': {
            tenantId: '87368623-d433-4142-8ede-1dc64be9c878',
            platformConfig: playtechPlatformConfig,
            products: (_b = {},
                _b[Registry_1.registry.products.luckysix.name] = {
                    productId: '7b39a453-1b82-43ed-8f8e-06309952f6dd',
                },
                _b),
        },
        'casapariurilorstg': {
            tenantId: '40d97b42-747d-485b-b017-1ac60835dde5',
            platformConfig: playtechPlatformConfig,
            products: (_c = {},
                _c[Registry_1.registry.products.luckysix.name] = {
                    productId: '6ce7f138-9779-499b-b6fa-8deef549e9cf',
                },
                _c),
        },
        'efortuna': {
            tenantId: '2059c5df-648e-4f75-8d3b-2d2229cb9377',
            platformConfig: playtechPlatformConfig,
            products: (_d = {},
                _d[Registry_1.registry.products.luckysix.name] = {
                    productId: '64de9299-a1ba-402c-978f-ce3236eba125',
                },
                _d),
        },
        'efortunastg.ro': {
            tenantId: '982a613e-3579-44e9-a62e-04b1aeb6d1b2',
            platformConfig: playtechPlatformConfig,
            products: (_e = {},
                _e[Registry_1.registry.products.luckysix.name] = {
                    productId: '8b0d31f9-9334-47f2-8957-c7eba49fa25d',
                },
                _e),
        },
        'ifortunastg.cz': {
            tenantId: '15c76b0e-ee45-4b89-af5b-788d7e5f351d',
            platformConfig: playtechPlatformConfig,
            products: (_f = {},
                _f[Registry_1.registry.products.luckysix.name] = {
                    productId: '4360746b-9a32-4a02-838d-603163383ef1',
                },
                _f),
        },
        'playtech850036': {
            tenantId: '6ecf50d5-8457-427f-9b20-60ae708ed9b6',
            platformConfig: playtechPlatformConfig,
            products: (_g = {},
                _g[Registry_1.registry.products.luckysix.name] = {
                    productId: 'dc4092c7-d93e-4006-8b9b-bc81ee5831af',
                },
                _g),
        },
        'playtech850037': {
            tenantId: '6ecf50d5-8457-427f-9b20-60ae708ed9b6',
            platformConfig: playtechPlatformConfig,
            products: (_h = {},
                _h[Registry_1.registry.products.luckysix.name] = {
                    productId: 'dc4092c7-d93e-4006-8b9b-bc81ee5831af',
                },
                _h),
        },
    },
};
//# sourceMappingURL=TenantProductRegistry.js.map